import { render, staticRenderFns } from "./submitAudit.vue?vue&type=template&id=37d10500&scoped=true&"
import script from "./submitAudit.vue?vue&type=script&lang=js&"
export * from "./submitAudit.vue?vue&type=script&lang=js&"
import style0 from "./submitAudit.vue?vue&type=style&index=0&id=37d10500&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d10500",
  null
  
)

export default component.exports